@if (componentData?.data$ | async; as data) {
  @if (data.title || data.description) {
    <boels-vertical-aligner
      [ngClass]="getMessageClass(GlobalMessageType.MSG_TYPE_WARNING)"
      class="boels-global-message__inner -cms-component-data"
    >
      <ng-container
        *ngTemplateOutlet="
          messageContent;
          context: {
            title: data.title,
            description: data.description,
            type: GlobalMessageType.MSG_TYPE_WARNING,
            index: -1,
          }
        "
      ></ng-container>
    </boels-vertical-aligner>
  }
} @else {
  @if ($messages(); as messages) {
    @for (type of getMessageTypes(messages); track $index) {
      <boels-vertical-aligner
        [ngClass]="getMessageClass(type)"
        class="boels-global-message__inner -messages"
      >
        @for (msg of messages[type]; track msg; let i = $index) {
          <ng-container
            *ngTemplateOutlet="
              messageContent;
              context: { msg: msg, type: type, index: i }
            "
          ></ng-container>
        }
      </boels-vertical-aligner>
    }
  }
}

<ng-template
  #messageContent
  let-msg="msg"
  let-type="type"
  let-description="description"
  let-title="title"
  let-index="index"
>
  <div class="boels-global-message__content">
    <fa-icon
      [icon]="getMessageIcon(type)"
      class="boels-global-message__icon"
      aria-hidden="true"
      role="none"
    ></fa-icon>
    @if (title) {
      <p
        aria-live="assertive"
        class="boels-global-message__title"
        role="alert"
        tabindex="0"
      >
        {{ title }}
      </p>
    }

    @if (description) {
      <p
        aria-live="assertive"
        class="boels-global-message__description"
        role="alert"
        tabindex="0"
        [innerHTML]="description | safeHtml"
      ></p>
    }

    @if (msg) {
      <p
        aria-live="assertive"
        class="boels-global-message__msg"
        role="alert"
        tabindex="0"
        [innerHTML]="msg | safeHtml"
      ></p>
    }

    <button
      type="button"
      class="boels-global-message__close-button"
      role="button"
      tabindex="0"
      aria-label="close message"
      (click)="clear(type, index)"
    >
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>
</ng-template>
